import { render, staticRenderFns } from "./Linked.vue?vue&type=template&id=203f2523&"
import script from "./Linked.vue?vue&type=script&lang=js&"
export * from "./Linked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports